import { getErrorMessage } from "@/lib/utils";

export function getPhoneValidationError(phone: string) {
  const value = phone.trim();
  if (!value) {
    return "A telefonszám megadása kötelező.";
  }

  const digits = value.replace(/\D/g, "");
  if (
    value.length > 32 ||
    !/^[+0-9][0-9 +()./-]{5,31}$/.test(value) ||
    digits.length < 8 ||
    digits.length > 15
  ) {
    return "Adjon meg érvényes telefonszámot.";
  }

  return null;
}

export function getAuthErrorMessage(error: unknown) {
  const message = getErrorMessage(error).toLowerCase();
  const code =
    error && typeof error === "object" && "code" in error
      ? String(error.code)
      : "";
  const emailTaken =
    message.includes("e-mail címmel már van fiók") ||
    message.includes("user already registered") ||
    message.includes("already been registered") ||
    message.includes("email address is already") ||
    (code === "23505" && message.includes("email"));
  const stampTaken =
    message.includes("pecsétszámmal már van") ||
    message.includes("profiles_registry_number_unique") ||
    (code === "23505" && message.includes("registry"));

  if (message.includes("invalid login credentials")) {
    return "Hibás e-mail cím vagy jelszó.";
  }
  if (message.includes("email not confirmed")) {
    return "Az e-mail cím még nincs megerősítve.";
  }
  if (emailTaken && stampTaken) {
    return "Ezzel az e-mail címmel már van fiók. Jelentkezzen be. Ezzel a pecsétszámmal már van regisztrált fiók.";
  }
  if (emailTaken) {
    return "Ezzel az e-mail címmel már van fiók. Jelentkezzen be.";
  }
  if (stampTaken) {
    return "Ezzel a pecsétszámmal már van regisztrált fiók.";
  }
  if (message.includes("telefonszám megadása kötelező")) {
    return "A telefonszám megadása kötelező.";
  }
  if (message.includes("érvényes telefonszámot")) {
    return "Adjon meg érvényes telefonszámot.";
  }
  if (
    message.includes("new password should be different") ||
    message.includes("should be different from the old password")
  ) {
    return "Az új jelszó nem egyezhet meg a jelenlegi jelszóval.";
  }
  if (message.includes("password")) {
    return "A jelszó nem felel meg a követelményeknek. Legalább 8 karakter legyen.";
  }
  if (
    message.includes("rate limit") ||
    message.includes("too many") ||
    message.includes("only request this once") ||
    message.includes("for security purposes")
  ) {
    return "Túl sok próbálkozás. Kérjük, várjon egy percet.";
  }
  if (
    message.includes("otp_expired") ||
    message.includes("token has expired") ||
    message.includes("email link is invalid") ||
    message.includes("invalid or expired")
  ) {
    return "A jelszó-visszaállító link érvénytelen vagy lejárt. Kérjen újat.";
  }

  return getErrorMessage(error);
}

export function isSafeNextPath(value: string | null) {
  return Boolean(value && value.startsWith("/") && !value.startsWith("//"));
}
